import fetchAx from "@/axios.js";
import { comAxiosWithToken } from "../../utils/communucationApi";
export default {
  namespaced: true,
  state: {
    users: [],
    searchQuery: "",
    sorting: 1,
  },
  mutations: {
    setUsers(state, payload) {
      state.users = payload;
    },
    addCustomerSupInList(state, payload) {
      payload.forEach((element) => {
        state.users.forEach((user) => {
          if (Number(user.d7K_ID) === Number(element.d7K_Id)) {
            user.isAgent = true;
          }
        });
      });
    },
    setSearchQuery(state, payload) {
      state.searchQuery = payload;
    },
    setSorting(state, payload) {
      state.sorting = payload;
    },
  },
  getters: {
    getUsers(state) {
      return state.users
        .filter((user) => {
          return (
            user.fullName.toLowerCase().includes(state.searchQuery) ||
            user.email.toLowerCase().includes(state.searchQuery) ||
            user.title.toLowerCase().includes(state.searchQuery)
          );
        })
        .sort((a, b) => {
          if (state.sorting == 1) {
            return a.fullName.localeCompare(b.fullName);
          } else if (state.sorting == 2) {
            return a.email.localeCompare(b.email);
          } else if (state.sorting == 3) {
            return a.title.localeCompare(b.title);
          } else if (state.sorting == 4) {
            return a.isDefaultAgent - b.isDefaultAgent;
          } else if (state.sorting == 5) {
            return a.isAgent - b.isAgent;
          } else if (state.sorting == 11) {
            return b.fullName.localeCompare(a.fullName);
          } else if (state.sorting == 22) {
            return b.email.localeCompare(a.email);
          } else if (state.sorting == 33) {
            return b.title.localeCompare(a.title);
          } else if (state.sorting == 44) {
            return b.isDefaultAgent - a.isDefaultAgent;
          } else if (state.sorting == 55) {
            return b.isAgent - a.isAgent;
          }
        });
    },
    getSearchQuery: (state) => state.searchQuery,
    getSorting: (state) => state.sorting,
  },
  actions: {
    async getAllUsers({ commit }) {
      await comAxiosWithToken()
        .get(`/api/Agent`)
        .then((response) => {
          commit("setUsers", response.data);
        })
        .catch((error) => {});
    },
    async addCustomerSupport({ commit }, payload) {
      try {
        await comAxiosWithToken()
          .post("/api/Agent", payload)
          .then((response) => {});
        commit("addCustomerSupInList", payload);
      } catch (error) {}
    },
    async deleteCustomer({ commit, dispatch }, list) {
      const idList = [];
      list.forEach((item) => {
        idList.push(item.d7K_ID);
      });
      await comAxiosWithToken()
        .delete(`/api/Agent`, { data: idList })
        .then((response) => {
          dispatch("getAllUsers");
        })
        .catch((error) => {});
    },
    async updateDefaultAgent({}, id) {
      await comAxiosWithToken()
        .put("api/Agent/updateisdefaultagent?id=" + id)
        .then((response) => {});
    },
  },
};
